<template>
  <div class="container">
   <div class="banner" :style="'background-image:url('+ bannerUrl +')'">
      <Nav></Nav> 
    </div>
  <!--介绍-->
  <div class="middle">
    <div class="introduce">
      <div class="title">{{title}}</div>
      <div class="time">{{time}}</div>
      <div class="detail" v-html="detail">
        <!-- <p>想国崇艺幼儿园是崇文理想国的联盟园，坐落于萧山经济开发区宁税路351号。是一家以“艺术教育”为特色的全日制高端国际幼儿园。</p>
        <div class="title_detail">办园宗旨</div>
        <p>“传导崇尚艺术之美”为核心理念，在真善美教育的基础上，以艺术性、创造性、主体性、独特性为办园目标，培养有艺术气质的快乐儿童。</p>
        <div class="title_detail">园区设施</div>
        <p> 整体装修风格现代、简洁、舒适、安全，独特的标识设计——恐龙蛋，蕴涵了新生命、新希望、新未来。全园配备智能化管理系统、全地暖系统与新风空气系统，设有多个专业化活动室——儿童剧场、专业演播厅、专业录音棚、恒温游泳池、多功能厅、舞蹈室、音乐室、创意美工坊、生活实践室等。</p>
        <div class="title_detail">师资配备</div>
        <p>每个班级配备3名教师（2名带班老师，1名生活老师）；同时配备外教、游泳教练、声乐、舞蹈、器乐等一流专业教师。</p>
        <div class="title_detail">课程设置</div>
        <p>整体课程游戏以“艺术表现”与“运动健康”为主线设计，创设“音乐之声”，“舞蹈之律”，“诵读之韵”三大板块内容，以艺术为钥匙开启孩子精彩的成长之门。</p>
        <div class="title_detail">教学方式</div>
        <p>采用定班与走班相结合、分龄与混龄相结合、基础课程与艺术课程相结合的形式，全面实施艺术创新授课制。</p> -->
      </div>
    </div>
    <!--返回按钮-->
    <div class="back" @click="back()"></div>
  </div>
  <!--底部-->
   <Footer></Footer>
  </div>
</template>
<script>
import Nav from '../../components/Nav';
import Footer from '../../components/Footer'
export default {
  components:{Nav,Footer},
  name:'Enter',
  data(){
    return{
      bannerUrl:'',
      title:'',
      detail:'',
      time:''
    }
  },
  methods:{
    back(){
     window.opener=null;window.close()
    }
  },
  beforeCreate(){
     this.$route.query.id
     switch(this.$route.query.Routingaddress){
        case 'Children':
         this.$http.post('/api/children/getInfo', {
             id:this.$route.query.id
            }).then( (res)=> {
                // console.log(res.data.data)
              var code=res.data.code;
              if(code===0){
                this.bannerUrl=res.data.data.banner
                this.title=res.data.data.case.title
                this.detail=res.data.data.case.content
                this.time=res.data.data.case.time
              }
            }).catch(function (error) {
              // console.log(error);
          });
        break
        case 'Notice':
         this.$http.post('/api/notice/getInfo', {
             id:this.$route.query.id
            }).then( (res)=> {
                // console.log(res.data.data)
              var code=res.data.code;
              if(code===0){
                this.bannerUrl=res.data.data.banner
                this.title=res.data.data.case.title
                this.detail=res.data.data.case.content
                 this.time=res.data.data.case.time
              }
            }).catch(function (error) {
              // console.log(error);
          });
        break
        case 'School':
         this.$http.post('/api/parent/getInfo', {
             id:this.$route.query.id
            }).then( (res)=> {
                // console.log(res.data.data)
              var code=res.data.code;
              if(code===0){
                this.bannerUrl=res.data.data.banner
                this.title=res.data.data.case.title
                this.detail=res.data.data.case.content
                 this.time=res.data.data.case.time
              }
            }).catch(function (error) {
              // console.log(error);
          });
        break
         case 'Caucus':
         this.$http.post('/api/caucus/getInfo', {
             id:this.$route.query.id
            }).then( (res)=> {
                // console.log(res.data.data)
              var code=res.data.code;
              if(code===0){
                this.bannerUrl=res.data.data.banner
                this.title=res.data.data.case.title
                this.detail=res.data.data.case.content
                 this.time=res.data.data.case.time
              }
            }).catch(function (error) {
              // console.log(error);
          });
        break
        
     }
  },
 
}
</script>
<style scoped>

.container{
 background-color:rgb(244,247,250);
 min-width: max-content;
 min-width: -moz-max-content;
}
.banner{
  overflow: hidden !important;
}
.banner{
  position: relative;
  background-image: url('../../assets/banner1.png');
  width: 100%;
  min-width: 1200px;
  height: 366px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.textimg_father{
  width: 63%;
  margin: 0 auto;
  width: 22.5vw;
  height: 2vw;
  max-width: 466px;
  max-height: 36px;
}
.textimg{
  width: 22.5vw;
  height: 2vw;
  max-width: 466px;
  max-height: 36px;
  position: absolute;
  top:55%;
  left: 19%;

}
.textimg img{
 
 width: 100%;
 height: 100%;
 object-fit: cover;
  /* position: absolute;
  top:12.5rem;
  left: 20.75rem; */
}
.middle{
  width: 1200px;
  margin: 0 auto;
  background-color: rgb(255, 255, 255);
  margin-bottom: -330px;
  padding-bottom: 450px;
  
}
.introduce{
 width:1037px;
 margin: 0 auto;
 padding-top: 50px;
}
.introduce .title{
  font-size: 28px;
  text-align: center;
  font-weight: bolder;
  color: rgb(64, 64, 64)
}
.detail{
  margin-top:50px;
}
.detail p{
  font-size: 18px;
  color:rgb(89, 89, 89);
  text-indent: 2em !important;
  line-height: 50px;
}
.detail p:nth-child(1){
   margin-top:40px;
}
.title_detail{
  font-size: 18px;
   color:rgb(246, 170, 0);
}
.time{
  width: 100%;
  margin: 0 auto;
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  color: #ccc;
}
.back{
 background-image: url('../../assets/back_button_03.png');
 width: 139px;
 height: 53px;
 margin: 0 auto;
 position: relative;
 top:120px;
}
.back:hover{
  cursor: pointer;

}
</style>


// WEBPACK FOOTER //
// src/pages/pcPages/NewsDetail.vue